// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"41cba5f08dd53c8433d1","691":"fd3247d005f346890d0a"}[chunkId] + ".js";
};